/*
 * Обёртка для MyTracker https://tracker.my.com/docs/sdk/web/api/
 * Использовать только после того как проинициализировалась версия трекера через скрипт,
 * в которой уже проброшена инфа о юзере
 */
import { AService, Params } from "./Service";
import { logDataInternally, transformParamsForDebugLog } from "./utils";

declare global {
    interface Window {
        _tmr: Array<IMyTrackerEvent>;
        _tmrCounterId?: number;
    }
}

export enum EventType {
    GOAL = 'reachGoal',
    START_TIMESPENT = 'startTimespent',
    STOP_TIMESPENT = 'stopTimespent',
    START_PLAYER_TIMESPENT = 'startAnytimeTimespent'
}

interface IMyTrackerEvent {
    type: EventType;
    id?: string | number;
    goal?: string;
    userid?: string;
    url?: string;
    referrer?: string;
    start?: number;
    pid?: number;
    params?: object;
}

export type GoalParams = Params & Pick<IMyTrackerEvent, 'userid' | 'params'>;

export type EventParams = GoalParams & Pick<IMyTrackerEvent, 'type'>;

class MyTrackerService extends AService {
    public readonly serviceName = 'my-tracker';

    protected readonly getId = () => window._tmrCounterId;

    protected getLogFunc = () => <Event extends IMyTrackerEvent>(ev: Event) => {
        window._tmr = window._tmr || [];
        window._tmr.push(ev);
    };

    protected sendGoalEvent(eventId: string, params: Params) {
        this.sendEvent({
            type: EventType.GOAL,
            id: this.getId(),
            goal: eventId,
            params: params,
        });
    }

    public trackCustomGoal(goal: string, goalParams?: GoalParams, withParamsSavingLog = true): void {
        if (!this.initWithDebug(`
            Custom Goal "${goal}".
            Params: "${transformParamsForDebugLog(goalParams)}".
        `)) {
            return;
        }

        const eventData = {
            id: this.getId(),
            type: EventType.GOAL,
            goal,
            ...goalParams,
        };
        this.sendEvent(eventData);

        if (withParamsSavingLog) {
            logDataInternally(this.logPrefix, this.serviceName, eventData.type);
        }
    }

    public trackCustomEvent(eventParams: EventParams, withParamsSavingLog = true): void {
        if (!this.initWithDebug(`Custom event "${eventParams.type}"`)) {
            return;
        }
        this.sendEvent(eventParams);

        if (withParamsSavingLog) {
            logDataInternally(this.logPrefix, this.serviceName, eventParams.type);
        }
    }
}

export const myTrackerService = new MyTrackerService();
